var _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    gradientTransform: "matrix(0.75, 0, 0, 0.75, 0.0000045, 0)",
    y1: 0,
    x2: 499.999979,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "8416202fb0"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 28.999329%, 67.799377%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.309753%, 29.051208%, 67.886353%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.621033%, 29.104614%, 67.974854%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.932312%, 29.156494%, 68.061829%)",
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.243591%, 29.208374%, 68.148804%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.553345%, 29.260254%, 68.235779%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.864624%, 29.31366%, 68.32428%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.175903%, 29.36554%, 68.411255%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.487183%, 29.417419%, 68.499756%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.796936%, 29.469299%, 68.586731%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.108215%, 29.522705%, 68.673706%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.419495%, 29.574585%, 68.760681%)",
    offset: 0.0429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.730774%, 29.627991%, 68.849182%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.040527%, 29.679871%, 68.936157%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.351807%, 29.73175%, 69.024658%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.663086%, 29.78363%, 69.111633%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.974365%, 29.837036%, 69.198608%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.284119%, 29.888916%, 69.285583%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.595398%, 29.940796%, 69.374084%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.906677%, 29.992676%, 69.46106%)",
    offset: 0.0742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.217957%, 30.046082%, 69.549561%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.529236%, 30.097961%, 69.636536%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.840515%, 30.151367%, 69.723511%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.150269%, 30.203247%, 69.810486%)",
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.461548%, 30.255127%, 69.898987%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.772827%, 30.307007%, 69.985962%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.084106%, 30.360413%, 70.074463%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.39386%, 30.412292%, 70.161438%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.705139%, 30.464172%, 70.249939%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.016418%, 30.516052%, 70.336914%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.327698%, 30.569458%, 70.423889%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.637451%, 30.621338%, 70.510864%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.94873%, 30.674744%, 70.599365%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.26001%, 30.726624%, 70.68634%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.571289%, 30.778503%, 70.774841%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.881042%, 30.830383%, 70.861816%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.192322%, 30.883789%, 70.948792%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.503601%, 30.935669%, 71.035767%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.81488%, 30.987549%, 71.124268%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.12616%, 31.039429%, 71.211243%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.437439%, 31.092834%, 71.299744%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.747192%, 31.144714%, 71.386719%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.058472%, 31.19812%, 71.473694%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.369751%, 31.25%, 71.560669%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.68103%, 31.30188%, 71.64917%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.990784%, 31.35376%, 71.736145%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.302063%, 31.407166%, 71.824646%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.613342%, 31.459045%, 71.911621%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.924622%, 31.512451%, 71.998596%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.234375%, 31.564331%, 72.085571%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.545654%, 31.616211%, 72.174072%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.856934%, 31.668091%, 72.261047%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.168213%, 31.721497%, 72.349548%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.477966%, 31.773376%, 72.436523%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.789246%, 31.825256%, 72.523499%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.100525%, 31.877136%, 72.610474%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.411804%, 31.930542%, 72.698975%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.723083%, 31.982422%, 72.78595%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.034363%, 32.035828%, 72.874451%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.344116%, 32.087708%, 72.961426%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.655396%, 32.139587%, 73.049927%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.966675%, 32.191467%, 73.136902%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.277954%, 32.244873%, 73.223877%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.587708%, 32.296753%, 73.310852%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.898987%, 32.348633%, 73.399353%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.210266%, 32.400513%, 73.486328%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.521545%, 32.453918%, 73.574829%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.831299%, 32.505798%, 73.661804%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.142578%, 32.559204%, 73.748779%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.453857%, 32.611084%, 73.835754%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.765137%, 32.662964%, 73.924255%)",
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.07489%, 32.714844%, 74.01123%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.386169%, 32.76825%, 74.099731%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.697449%, 32.820129%, 74.186707%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.008728%, 32.872009%, 74.273682%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.318481%, 32.923889%, 74.360657%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.629761%, 32.977295%, 74.449158%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.94104%, 33.029175%, 74.536133%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.252319%, 33.082581%, 74.624634%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.563599%, 33.13446%, 74.711609%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.874878%, 33.18634%, 74.798584%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.184631%, 33.23822%, 74.885559%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.495911%, 33.291626%, 74.97406%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.80719%, 33.343506%, 75.061035%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.118469%, 33.395386%, 75.149536%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.428223%, 33.447266%, 75.236511%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.739502%, 33.500671%, 75.323486%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.050781%, 33.552551%, 75.410461%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.362061%, 33.605957%, 75.498962%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.671814%, 33.657837%, 75.585938%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.983093%, 33.709717%, 75.674438%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.294373%, 33.761597%, 75.761414%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.605652%, 33.815002%, 75.849915%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.915405%, 33.866882%, 75.93689%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.226685%, 33.920288%, 76.023865%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.537964%, 33.972168%, 76.11084%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.849243%, 34.024048%, 76.199341%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.160522%, 34.075928%, 76.286316%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.471802%, 34.129333%, 76.374817%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.781555%, 34.181213%, 76.461792%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.092834%, 34.233093%, 76.548767%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.404114%, 34.284973%, 76.635742%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.715393%, 34.338379%, 76.724243%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.025146%, 34.390259%, 76.811218%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.336426%, 34.443665%, 76.899719%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.647705%, 34.495544%, 76.986694%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.958984%, 34.547424%, 77.073669%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.268738%, 34.599304%, 77.160645%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.580017%, 34.65271%, 77.249146%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.891296%, 34.70459%, 77.336121%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.202576%, 34.75647%, 77.424622%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.512329%, 34.80835%, 77.511597%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.823608%, 34.861755%, 77.598572%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.134888%, 34.913635%, 77.685547%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.446167%, 34.967041%, 77.774048%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.757446%, 35.018921%, 77.861023%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.068726%, 35.070801%, 77.949524%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.378479%, 35.122681%, 78.036499%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.689758%, 35.176086%, 78.123474%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.001038%, 35.227966%, 78.210449%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.312317%, 35.279846%, 78.29895%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.62207%, 35.331726%, 78.385925%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.93335%, 35.385132%, 78.474426%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.244629%, 35.437012%, 78.561401%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.555908%, 35.490417%, 78.649902%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.865662%, 35.542297%, 78.736877%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.176941%, 35.594177%, 78.823853%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.48822%, 35.646057%, 78.910828%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.7995%, 35.699463%, 78.999329%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.109253%, 35.751343%, 79.086304%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.420532%, 35.803223%, 79.174805%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.731812%, 35.855103%, 79.26178%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.043091%, 35.908508%, 79.348755%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.352844%, 35.960388%, 79.43573%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.664124%, 36.013794%, 79.524231%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.975403%, 36.065674%, 79.611206%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.286682%, 36.117554%, 79.699707%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.597961%, 36.169434%, 79.786682%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.909241%, 36.222839%, 79.873657%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.218994%, 36.274719%, 79.960632%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.530273%, 36.326599%, 80.049133%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.841553%, 36.378479%, 80.136108%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.152832%, 36.431885%, 80.224609%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.462585%, 36.483765%, 80.311584%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.773865%, 36.53717%, 80.39856%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.085144%, 36.58905%, 80.485535%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.396423%, 36.64093%, 80.574036%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.706177%, 36.69281%, 80.661011%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.017456%, 36.746216%, 80.749512%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.328735%, 36.798096%, 80.836487%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.640015%, 36.851501%, 80.924988%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.949768%, 36.903381%, 81.011963%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.261047%, 36.955261%, 81.098938%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.572327%, 37.007141%, 81.185913%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.883606%, 37.060547%, 81.274414%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.194885%, 37.112427%, 81.361389%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.506165%, 37.164307%, 81.44989%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.815918%, 37.216187%, 81.536865%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.127197%, 37.269592%, 81.62384%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.438477%, 37.321472%, 81.710815%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.749756%, 37.374878%, 81.799316%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.059509%, 37.426758%, 81.886292%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.370789%, 37.478638%, 81.974792%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.682068%, 37.530518%, 82.061768%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.993347%, 37.583923%, 82.148743%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.303101%, 37.635803%, 82.235718%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.61438%, 37.687683%, 82.324219%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.925659%, 37.739563%, 82.411194%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.236938%, 37.792969%, 82.499695%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.546692%, 37.844849%, 82.58667%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.857971%, 37.898254%, 82.673645%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.16925%, 37.950134%, 82.76062%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.48053%, 38.002014%, 82.849121%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.791809%, 38.053894%, 82.936096%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.103088%, 38.1073%, 83.024597%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.412842%, 38.15918%, 83.111572%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.724121%, 38.21106%, 83.198547%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.0354%, 38.262939%, 83.285522%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.34668%, 38.316345%, 83.374023%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.656433%, 38.368225%, 83.460999%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.967712%, 38.421631%, 83.5495%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.278992%, 38.473511%, 83.636475%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.590271%, 38.525391%, 83.724976%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.900024%, 38.577271%, 83.811951%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.211304%, 38.630676%, 83.898926%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.522583%, 38.682556%, 83.985901%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.833862%, 38.734436%, 84.074402%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.143616%, 38.786316%, 84.161377%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.454895%, 38.839722%, 84.249878%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.766174%, 38.891602%, 84.336853%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.077454%, 38.945007%, 84.423828%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.387207%, 38.996887%, 84.510803%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.698486%, 39.048767%, 84.599304%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.009766%, 39.100647%, 84.686279%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.321045%, 39.154053%, 84.77478%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.632324%, 39.205933%, 84.861755%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.943604%, 39.259338%, 84.94873%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.253357%, 39.311218%, 85.035706%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.564636%, 39.363098%, 85.124207%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.875916%, 39.414978%, 85.211182%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.187195%, 39.468384%, 85.299683%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.496948%, 39.520264%, 85.386658%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.808228%, 39.572144%, 85.473633%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.119507%, 39.624023%, 85.560608%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.430786%, 39.677429%, 85.649109%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.74054%, 39.729309%, 85.736084%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.051819%, 39.782715%, 85.824585%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.363098%, 39.834595%, 85.91156%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.674377%, 39.886475%, 85.998535%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.984131%, 39.938354%, 86.08551%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.29541%, 39.99176%, 86.174011%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.606689%, 40.04364%, 86.260986%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.917969%, 40.09552%, 86.349487%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.229248%, 40.1474%, 86.436462%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.540527%, 40.200806%, 86.524963%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.850281%, 40.252686%, 86.611938%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.16156%, 40.306091%, 86.698914%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.472839%, 40.357971%, 86.785889%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.784119%, 40.409851%, 86.87439%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.093872%, 40.461731%, 86.961365%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.405151%, 40.515137%, 87.049866%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.716431%, 40.567017%, 87.136841%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.02771%, 40.618896%, 87.223816%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.337463%, 40.670776%, 87.310791%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.648743%, 40.724182%, 87.399292%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.960022%, 40.776062%, 87.486267%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.271301%, 40.829468%, 87.574768%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.581055%, 40.881348%, 87.661743%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.892334%, 40.933228%, 87.748718%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.203613%, 40.985107%, 87.835693%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.514893%, 41.038513%, 87.924194%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.826172%, 41.090393%, 88.011169%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.137451%, 41.142273%, 88.09967%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.447205%, 41.194153%, 88.186646%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.758484%, 41.247559%, 88.273621%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.069763%, 41.299438%, 88.360596%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.381042%, 41.352844%, 88.449097%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.690796%, 41.404724%, 88.536072%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.002075%, 41.456604%, 88.624573%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.313354%, 41.508484%, 88.711548%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.624634%, 41.56189%, 88.798523%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.934387%, 41.61377%, 88.885498%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.245667%, 41.667175%, 88.973999%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.556946%, 41.719055%, 89.060974%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.868225%, 41.770935%, 89.149475%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.177979%, 41.822815%, 89.23645%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.489258%, 41.876221%, 89.324951%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.800537%, 41.928101%, 89.411926%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.111816%, 41.97998%, 89.498901%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.42157%, 42.03186%, 89.585876%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.732849%, 42.085266%, 89.674377%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.044128%, 42.137146%, 89.761353%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.355408%, 42.190552%, 89.849854%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.666687%, 42.242432%, 89.936829%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.977966%, 42.294312%, 90.023804%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.28772%, 42.346191%, 90.110779%)",
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.598999%, 42.399597%, 90.19928%)",
    offset: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    fill: "url(#8416202fb0)",
    width: 450,
    y: -37.499999,
    height: 449.999989
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.712768, 226.274659)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.375 -124.996094 L 56.125 0 L 62.875 0 L 80.5 -49.875 C 81.125 -51.625 81.875 -52.5 82.625 -52.5 C 83.5 -52.5 84.375 -51.75 85.125 -50 L 107.5 0 L 114.25 0 L 158.496094 -124.996094 L 147.496094 -124.996094 L 116.125 -15.875 C 115.5 -13.875 114.75 -12.875 113.875 -12.875 C 113.125 -12.875 112.25 -13.75 111.5 -15.5 L 90 -63.75 C 88.5 -67.125 88.375 -71.875 89.625 -75.375 L 107.125 -124.996094 L 96.125 -124.996094 L 84.75 -85.5 C 84.25 -83.625 83.5 -82.75 82.75 -82.75 C 82 -82.75 81.25 -83.625 80.5 -85.25 L 62.75 -124.996094 L 51.75 -124.996094 L 76.25 -70.25 C 77.75 -66.875 78 -62.125 77 -58.5 L 64.75 -15.875 C 64.125 -13.875 63.375 -12.875 62.5 -12.875 C 61.75 -12.875 60.875 -13.75 60.125 -15.5 L 11.375 -124.996094 Z M 0.375 -124.996094 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.76766, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.5 0 C 17.238281 0 17.050781 -0.113281 16.9375 -0.34375 L 11.875 -11.015625 C 11.832031 -11.109375 11.765625 -11.15625 11.671875 -11.15625 L 5.890625 -11.15625 C 5.773438 -11.15625 5.71875 -11.097656 5.71875 -10.984375 L 5.71875 -0.453125 C 5.71875 -0.148438 5.566406 0 5.265625 0 L 3.703125 0 C 3.398438 0 3.25 -0.148438 3.25 -0.453125 L 3.25 -23.828125 C 3.25 -24.128906 3.398438 -24.28125 3.703125 -24.28125 L 12.578125 -24.28125 C 14.554688 -24.28125 16.15625 -23.664062 17.375 -22.4375 C 18.601562 -21.21875 19.21875 -19.613281 19.21875 -17.625 C 19.21875 -16.007812 18.785156 -14.640625 17.921875 -13.515625 C 17.054688 -12.398438 15.875 -11.671875 14.375 -11.328125 C 14.257812 -11.304688 14.222656 -11.238281 14.265625 -11.125 L 19.4375 -0.515625 C 19.476562 -0.421875 19.5 -0.351562 19.5 -0.3125 C 19.5 -0.101562 19.363281 0 19.09375 0 Z M 5.890625 -22.140625 C 5.773438 -22.140625 5.71875 -22.082031 5.71875 -21.96875 L 5.71875 -13.296875 C 5.71875 -13.179688 5.773438 -13.125 5.890625 -13.125 L 12.296875 -13.125 C 13.640625 -13.125 14.722656 -13.535156 15.546875 -14.359375 C 16.378906 -15.179688 16.796875 -16.257812 16.796875 -17.59375 C 16.796875 -18.9375 16.378906 -20.03125 15.546875 -20.875 C 14.722656 -21.71875 13.640625 -22.140625 12.296875 -22.140625 Z M 5.890625 -22.140625 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.859004, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 18.953125 -22.546875 C 18.953125 -22.242188 18.800781 -22.09375 18.5 -22.09375 L 5.890625 -22.09375 C 5.773438 -22.09375 5.71875 -22.035156 5.71875 -21.921875 L 5.71875 -13.4375 C 5.71875 -13.320312 5.773438 -13.265625 5.890625 -13.265625 L 14.6875 -13.265625 C 14.988281 -13.265625 15.140625 -13.113281 15.140625 -12.8125 L 15.140625 -11.5625 C 15.140625 -11.269531 14.988281 -11.125 14.6875 -11.125 L 5.890625 -11.125 C 5.773438 -11.125 5.71875 -11.066406 5.71875 -10.953125 L 5.71875 -2.328125 C 5.71875 -2.203125 5.773438 -2.140625 5.890625 -2.140625 L 18.5 -2.140625 C 18.800781 -2.140625 18.953125 -1.992188 18.953125 -1.703125 L 18.953125 -0.453125 C 18.953125 -0.148438 18.800781 0 18.5 0 L 3.703125 0 C 3.398438 0 3.25 -0.148438 3.25 -0.453125 L 3.25 -23.796875 C 3.25 -24.097656 3.398438 -24.25 3.703125 -24.25 L 18.5 -24.25 C 18.800781 -24.25 18.953125 -24.097656 18.953125 -23.796875 Z M 18.953125 -22.546875 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.707858, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.28125 0 C 9.03125 0 8.867188 -0.125 8.796875 -0.375 L 1.28125 -23.734375 C 1.257812 -23.773438 1.25 -23.832031 1.25 -23.90625 C 1.25 -24 1.285156 -24.078125 1.359375 -24.140625 C 1.441406 -24.210938 1.539062 -24.25 1.65625 -24.25 L 3.328125 -24.25 C 3.578125 -24.25 3.738281 -24.125 3.8125 -23.875 L 10.109375 -3.734375 C 10.140625 -3.648438 10.175781 -3.609375 10.21875 -3.609375 C 10.257812 -3.609375 10.296875 -3.648438 10.328125 -3.734375 L 16.625 -23.875 C 16.695312 -24.125 16.859375 -24.25 17.109375 -24.25 L 18.734375 -24.25 C 18.898438 -24.25 19.015625 -24.203125 19.078125 -24.109375 C 19.148438 -24.015625 19.164062 -23.890625 19.125 -23.734375 L 11.53125 -0.375 C 11.46875 -0.125 11.304688 0 11.046875 0 Z M 9.28125 0 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.002464, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.703125 0 C 3.398438 0 3.25 -0.148438 3.25 -0.453125 L 3.25 -23.796875 C 3.25 -24.097656 3.398438 -24.25 3.703125 -24.25 L 5.265625 -24.25 C 5.566406 -24.25 5.71875 -24.097656 5.71875 -23.796875 L 5.71875 -0.453125 C 5.71875 -0.148438 5.566406 0 5.265625 0 Z M 3.703125 0 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.865693, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 18.953125 -22.546875 C 18.953125 -22.242188 18.800781 -22.09375 18.5 -22.09375 L 5.890625 -22.09375 C 5.773438 -22.09375 5.71875 -22.035156 5.71875 -21.921875 L 5.71875 -13.4375 C 5.71875 -13.320312 5.773438 -13.265625 5.890625 -13.265625 L 14.6875 -13.265625 C 14.988281 -13.265625 15.140625 -13.113281 15.140625 -12.8125 L 15.140625 -11.5625 C 15.140625 -11.269531 14.988281 -11.125 14.6875 -11.125 L 5.890625 -11.125 C 5.773438 -11.125 5.71875 -11.066406 5.71875 -10.953125 L 5.71875 -2.328125 C 5.71875 -2.203125 5.773438 -2.140625 5.890625 -2.140625 L 18.5 -2.140625 C 18.800781 -2.140625 18.953125 -1.992188 18.953125 -1.703125 L 18.953125 -0.453125 C 18.953125 -0.148438 18.800781 0 18.5 0 L 3.703125 0 C 3.398438 0 3.25 -0.148438 3.25 -0.453125 L 3.25 -23.796875 C 3.25 -24.097656 3.398438 -24.25 3.703125 -24.25 L 18.5 -24.25 C 18.800781 -24.25 18.953125 -24.097656 18.953125 -23.796875 Z M 18.953125 -22.546875 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.714548, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.96875 0 C 7.71875 0 7.554688 -0.125 7.484375 -0.375 L 0.90625 -23.734375 L 0.859375 -23.875 C 0.859375 -24.125 1 -24.25 1.28125 -24.25 L 2.984375 -24.25 C 3.234375 -24.25 3.394531 -24.125 3.46875 -23.875 L 8.65625 -5.09375 C 8.675781 -5.019531 8.707031 -4.984375 8.75 -4.984375 C 8.800781 -4.984375 8.84375 -5.019531 8.875 -5.09375 L 13.71875 -23.875 C 13.789062 -24.125 13.960938 -24.25 14.234375 -24.25 L 15.90625 -24.25 C 16.15625 -24.25 16.316406 -24.125 16.390625 -23.875 L 21.4375 -5.0625 C 21.46875 -4.988281 21.503906 -4.953125 21.546875 -4.953125 C 21.585938 -4.953125 21.625 -4.988281 21.65625 -5.0625 L 26.84375 -23.875 C 26.914062 -24.125 27.078125 -24.25 27.328125 -24.25 L 28.921875 -24.25 C 29.085938 -24.25 29.203125 -24.203125 29.265625 -24.109375 C 29.335938 -24.015625 29.351562 -23.890625 29.3125 -23.734375 L 22.828125 -0.375 C 22.753906 -0.125 22.59375 0 22.34375 0 L 20.6875 0 C 20.40625 0 20.226562 -0.125 20.15625 -0.375 L 15.171875 -19.640625 C 15.148438 -19.710938 15.113281 -19.75 15.0625 -19.75 C 15.019531 -19.75 14.988281 -19.710938 14.96875 -19.640625 L 10.046875 -0.375 C 9.972656 -0.125 9.800781 0 9.53125 0 Z M 7.96875 0 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(187.812437, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.328125 0.28125 C 8.640625 0.28125 7.164062 0.015625 5.90625 -0.515625 C 4.644531 -1.046875 3.671875 -1.800781 2.984375 -2.78125 C 2.304688 -3.769531 1.96875 -4.910156 1.96875 -6.203125 L 1.96875 -7.171875 C 1.96875 -7.472656 2.117188 -7.625 2.421875 -7.625 L 3.921875 -7.625 C 4.210938 -7.625 4.359375 -7.472656 4.359375 -7.171875 L 4.359375 -6.34375 C 4.359375 -5.019531 4.910156 -3.941406 6.015625 -3.109375 C 7.128906 -2.285156 8.625 -1.875 10.5 -1.875 C 12.269531 -1.875 13.617188 -2.25 14.546875 -3 C 15.472656 -3.75 15.9375 -4.75 15.9375 -6 C 15.9375 -6.800781 15.722656 -7.488281 15.296875 -8.0625 C 14.867188 -8.644531 14.210938 -9.191406 13.328125 -9.703125 C 12.453125 -10.210938 11.195312 -10.800781 9.5625 -11.46875 C 7.832031 -12.15625 6.488281 -12.757812 5.53125 -13.28125 C 4.570312 -13.800781 3.796875 -14.472656 3.203125 -15.296875 C 2.617188 -16.117188 2.328125 -17.148438 2.328125 -18.390625 C 2.328125 -20.328125 3 -21.832031 4.34375 -22.90625 C 5.695312 -23.988281 7.5625 -24.53125 9.9375 -24.53125 C 12.476562 -24.53125 14.488281 -23.925781 15.96875 -22.71875 C 17.445312 -21.519531 18.1875 -19.925781 18.1875 -17.9375 L 18.1875 -17.28125 C 18.1875 -16.976562 18.035156 -16.828125 17.734375 -16.828125 L 16.21875 -16.828125 C 15.914062 -16.828125 15.765625 -16.976562 15.765625 -17.28125 L 15.765625 -17.8125 C 15.765625 -19.144531 15.242188 -20.238281 14.203125 -21.09375 C 13.160156 -21.945312 11.691406 -22.375 9.796875 -22.375 C 8.160156 -22.375 6.910156 -22.039062 6.046875 -21.375 C 5.179688 -20.707031 4.75 -19.738281 4.75 -18.46875 C 4.75 -17.632812 4.960938 -16.945312 5.390625 -16.40625 C 5.816406 -15.863281 6.425781 -15.390625 7.21875 -14.984375 C 8.019531 -14.578125 9.238281 -14.050781 10.875 -13.40625 C 12.5625 -12.707031 13.925781 -12.054688 14.96875 -11.453125 C 16.007812 -10.859375 16.835938 -10.128906 17.453125 -9.265625 C 18.078125 -8.398438 18.390625 -7.34375 18.390625 -6.09375 C 18.390625 -4.175781 17.679688 -2.632812 16.265625 -1.46875 C 14.847656 -0.300781 12.867188 0.28125 10.328125 0.28125 Z M 10.328125 0.28125 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.003124, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(212.822559, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.703125 0 C 17.441406 0 17.28125 -0.125 17.21875 -0.375 L 15.828125 -4.609375 C 15.785156 -4.703125 15.726562 -4.75 15.65625 -4.75 L 5.328125 -4.75 C 5.265625 -4.75 5.207031 -4.703125 5.15625 -4.609375 L 3.8125 -0.375 C 3.738281 -0.125 3.578125 0 3.328125 0 L 1.65625 0 C 1.5 0 1.382812 -0.046875 1.3125 -0.140625 C 1.25 -0.234375 1.238281 -0.359375 1.28125 -0.515625 L 8.90625 -23.875 C 8.96875 -24.125 9.128906 -24.25 9.390625 -24.25 L 11.609375 -24.25 C 11.859375 -24.25 12.019531 -24.125 12.09375 -23.875 L 19.75 -0.515625 C 19.769531 -0.472656 19.78125 -0.414062 19.78125 -0.34375 C 19.78125 -0.25 19.738281 -0.164062 19.65625 -0.09375 C 19.570312 -0.03125 19.472656 0 19.359375 0 Z M 5.921875 -6.96875 C 5.898438 -6.820312 5.945312 -6.75 6.0625 -6.75 L 14.96875 -6.75 C 15.101562 -6.75 15.148438 -6.820312 15.109375 -6.96875 L 10.59375 -21.125 C 10.570312 -21.21875 10.535156 -21.265625 10.484375 -21.265625 C 10.441406 -21.265625 10.410156 -21.21875 10.390625 -21.125 Z M 5.921875 -6.96875 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.740702, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.640625 0.28125 C 9.015625 0.28125 7.585938 -0.0351562 6.359375 -0.671875 C 5.140625 -1.304688 4.191406 -2.203125 3.515625 -3.359375 C 2.835938 -4.515625 2.5 -5.84375 2.5 -7.34375 L 2.5 -16.90625 C 2.5 -18.40625 2.835938 -19.734375 3.515625 -20.890625 C 4.191406 -22.046875 5.140625 -22.941406 6.359375 -23.578125 C 7.585938 -24.210938 9.015625 -24.53125 10.640625 -24.53125 C 12.234375 -24.53125 13.644531 -24.21875 14.875 -23.59375 C 16.113281 -22.96875 17.066406 -22.09375 17.734375 -20.96875 C 18.398438 -19.851562 18.734375 -18.59375 18.734375 -17.1875 L 18.734375 -16.828125 C 18.734375 -16.535156 18.585938 -16.390625 18.296875 -16.390625 L 16.734375 -16.390625 C 16.429688 -16.390625 16.28125 -16.515625 16.28125 -16.765625 L 16.28125 -17.140625 C 16.28125 -18.691406 15.765625 -19.953125 14.734375 -20.921875 C 13.710938 -21.890625 12.347656 -22.375 10.640625 -22.375 C 8.929688 -22.375 7.554688 -21.878906 6.515625 -20.890625 C 5.472656 -19.898438 4.953125 -18.59375 4.953125 -16.96875 L 4.953125 -7.28125 C 4.953125 -5.65625 5.484375 -4.347656 6.546875 -3.359375 C 7.609375 -2.367188 9.003906 -1.875 10.734375 -1.875 C 12.421875 -1.875 13.765625 -2.332031 14.765625 -3.25 C 15.773438 -4.175781 16.28125 -5.414062 16.28125 -6.96875 L 16.28125 -10.078125 C 16.28125 -10.191406 16.222656 -10.25 16.109375 -10.25 L 11.15625 -10.25 C 10.851562 -10.25 10.703125 -10.398438 10.703125 -10.703125 L 10.703125 -11.953125 C 10.703125 -12.253906 10.851562 -12.40625 11.15625 -12.40625 L 18.296875 -12.40625 C 18.585938 -12.40625 18.734375 -12.253906 18.734375 -11.953125 L 18.734375 -7.59375 C 18.734375 -5.113281 18 -3.179688 16.53125 -1.796875 C 15.070312 -0.410156 13.109375 0.28125 10.640625 0.28125 Z M 10.640625 0.28125 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(252.624192, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 18.953125 -22.546875 C 18.953125 -22.242188 18.800781 -22.09375 18.5 -22.09375 L 5.890625 -22.09375 C 5.773438 -22.09375 5.71875 -22.035156 5.71875 -21.921875 L 5.71875 -13.4375 C 5.71875 -13.320312 5.773438 -13.265625 5.890625 -13.265625 L 14.6875 -13.265625 C 14.988281 -13.265625 15.140625 -13.113281 15.140625 -12.8125 L 15.140625 -11.5625 C 15.140625 -11.269531 14.988281 -11.125 14.6875 -11.125 L 5.890625 -11.125 C 5.773438 -11.125 5.71875 -11.066406 5.71875 -10.953125 L 5.71875 -2.328125 C 5.71875 -2.203125 5.773438 -2.140625 5.890625 -2.140625 L 18.5 -2.140625 C 18.800781 -2.140625 18.953125 -1.992188 18.953125 -1.703125 L 18.953125 -0.453125 C 18.953125 -0.148438 18.800781 0 18.5 0 L 3.703125 0 C 3.398438 0 3.25 -0.148438 3.25 -0.453125 L 3.25 -23.796875 C 3.25 -24.097656 3.398438 -24.25 3.703125 -24.25 L 18.5 -24.25 C 18.800781 -24.25 18.953125 -24.097656 18.953125 -23.796875 Z M 18.953125 -22.546875 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(272.473053, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.703125 0 C 3.398438 0 3.25 -0.148438 3.25 -0.453125 L 3.25 -23.796875 C 3.25 -24.097656 3.398438 -24.25 3.703125 -24.25 L 5.265625 -24.25 C 5.472656 -24.25 5.644531 -24.144531 5.78125 -23.9375 L 17.421875 -5.09375 C 17.472656 -5.019531 17.519531 -4.988281 17.5625 -5 C 17.601562 -5.007812 17.625 -5.0625 17.625 -5.15625 L 17.625 -23.796875 C 17.625 -24.097656 17.773438 -24.25 18.078125 -24.25 L 19.640625 -24.25 C 19.941406 -24.25 20.09375 -24.097656 20.09375 -23.796875 L 20.09375 -0.453125 C 20.09375 -0.148438 19.941406 0 19.640625 0 L 18.078125 0 C 17.867188 0 17.695312 -0.101562 17.5625 -0.3125 L 5.890625 -19.21875 C 5.835938 -19.289062 5.789062 -19.320312 5.75 -19.3125 C 5.707031 -19.300781 5.6875 -19.25 5.6875 -19.15625 L 5.71875 -0.453125 C 5.71875 -0.148438 5.566406 0 5.265625 0 Z M 3.703125 0 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.677473, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.640625 0.3125 C 9.015625 0.3125 7.585938 -0.00390625 6.359375 -0.640625 C 5.140625 -1.273438 4.191406 -2.175781 3.515625 -3.34375 C 2.835938 -4.507812 2.5 -5.851562 2.5 -7.375 L 2.5 -16.90625 C 2.5 -18.40625 2.835938 -19.734375 3.515625 -20.890625 C 4.191406 -22.046875 5.140625 -22.941406 6.359375 -23.578125 C 7.585938 -24.210938 9.015625 -24.53125 10.640625 -24.53125 C 12.253906 -24.53125 13.671875 -24.21875 14.890625 -23.59375 C 16.117188 -22.96875 17.070312 -22.085938 17.75 -20.953125 C 18.4375 -19.828125 18.78125 -18.523438 18.78125 -17.046875 C 18.78125 -16.835938 18.628906 -16.707031 18.328125 -16.65625 L 16.765625 -16.5625 L 16.65625 -16.5625 C 16.570312 -16.5625 16.492188 -16.582031 16.421875 -16.625 C 16.347656 -16.675781 16.3125 -16.722656 16.3125 -16.765625 L 16.3125 -16.96875 C 16.3125 -18.613281 15.789062 -19.925781 14.75 -20.90625 C 13.71875 -21.882812 12.347656 -22.375 10.640625 -22.375 C 8.929688 -22.375 7.554688 -21.878906 6.515625 -20.890625 C 5.472656 -19.898438 4.953125 -18.59375 4.953125 -16.96875 L 4.953125 -7.28125 C 4.953125 -5.65625 5.472656 -4.347656 6.515625 -3.359375 C 7.554688 -2.367188 8.929688 -1.875 10.640625 -1.875 C 12.347656 -1.875 13.71875 -2.363281 14.75 -3.34375 C 15.789062 -4.320312 16.3125 -5.632812 16.3125 -7.28125 C 16.3125 -7.550781 16.460938 -7.675781 16.765625 -7.65625 L 18.328125 -7.59375 C 18.628906 -7.59375 18.78125 -7.53125 18.78125 -7.40625 L 18.78125 -7.234375 C 18.78125 -5.734375 18.4375 -4.410156 17.75 -3.265625 C 17.070312 -2.128906 16.117188 -1.25 14.890625 -0.625 C 13.671875 0 12.253906 0.3125 10.640625 0.3125 Z M 10.640625 0.3125 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.595616, 266.06008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.046875 -0.03125 C 8.742188 -0.03125 8.59375 -0.179688 8.59375 -0.484375 L 8.59375 -10.640625 C 8.59375 -10.679688 8.566406 -10.75 8.515625 -10.84375 L 1.421875 -23.6875 C 1.367188 -23.832031 1.34375 -23.914062 1.34375 -23.9375 C 1.34375 -24.03125 1.378906 -24.101562 1.453125 -24.15625 C 1.523438 -24.21875 1.617188 -24.25 1.734375 -24.25 L 3.390625 -24.25 C 3.648438 -24.25 3.828125 -24.144531 3.921875 -23.9375 L 9.703125 -13.46875 C 9.765625 -13.382812 9.832031 -13.382812 9.90625 -13.46875 L 15.734375 -23.9375 C 15.847656 -24.144531 16.019531 -24.25 16.25 -24.25 L 17.90625 -24.25 C 18.09375 -24.25 18.210938 -24.195312 18.265625 -24.09375 C 18.328125 -23.988281 18.3125 -23.851562 18.21875 -23.6875 L 11.125 -10.84375 C 11.070312 -10.75 11.046875 -10.679688 11.046875 -10.640625 L 11.046875 -0.484375 C 11.046875 -0.179688 10.894531 -0.03125 10.59375 -0.03125 Z M 9.046875 -0.03125 "
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf63",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.74832, 225.983424)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.003906 0 L 20.007812 0 C 20.007812 0 19.882812 -110.910156 19.882812 -114.660156 C 19.882812 -121.414062 22.007812 -122.539062 26.507812 -122.539062 L 56.519531 -122.539062 C 81.527344 -122.539062 94.65625 -109.785156 94.65625 -89.402344 C 94.65625 -69.023438 81.527344 -56.269531 56.519531 -56.269531 L 32.011719 -56.269531 L 32.011719 -53.765625 L 43.140625 -53.765625 C 58.144531 -53.765625 78.148438 -10.628906 95.90625 0 L 110.035156 0 C 104.410156 -3.75 94.65625 -12.753906 86.902344 -23.132812 C 77.773438 -35.386719 70.898438 -44.765625 63.894531 -50.265625 C 60.894531 -52.640625 60.144531 -53.765625 63.894531 -53.765625 L 67.523438 -53.765625 C 99.40625 -54.140625 106.535156 -76.898438 106.535156 -89.402344 C 106.535156 -101.90625 99.40625 -125.039062 67.523438 -125.039062 L 10.003906 -125.039062 Z M 10.003906 0 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8db43e1381c7d1131a025584c3693719.svg";
export { ForwardRef as ReactComponent };